module.exports = __webpack_public_path__ + "img/appIcon-menu--Revenue.86ce731b.svg";